import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
const ax = axios.create({ baseURL: API, withCredentials: true });

// Root /api client for cross-cutting self-service endpoints (My Profile).
const axRoot = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

// --- My Profile (any logged-in user) ---
export const getMyProfile = () => axRoot.get("/me").then(r => r.data);
export const updateMyProfile = (name) => axRoot.patch("/me/profile", { name }).then(r => r.data);
export const changeMyPassword = (current_password, new_password) =>
  axRoot.post("/me/change-password", { current_password, new_password }).then(r => r.data);

export const adminLogin = (email, password) => ax.post("/auth/login", { email, password }).then(r => r.data);
export const adminLogout = () => ax.post("/auth/logout").then(r => r.data);
export const adminMe = () => ax.get("/auth/me").then(r => r.data);

export const listUsers = () => ax.get("/users").then(r => r.data);
export const createUser = (d) => ax.post("/users", d).then(r => r.data);
export const updateUser = (id, d) => ax.put(`/users/${id}`, d).then(r => r.data);
export const sendUserReset = (id) => ax.post(`/users/${id}/send-reset`).then(r => r.data);
// SmartEWM Multi-Client masters (read-only here — used to populate the Users
// access-scoping dropdowns).
export const listSmartewmClients = () => ax.get("/smartewm/clients").then(r => r.data);
export const listSmartewmSapSystems = (clientId) =>
  ax.get("/smartewm/sap-systems", { params: clientId ? { clientId } : {} }).then(r => r.data);
// SmartEWM Client Master CRUD.
export const createSmartewmClient = (d) => ax.post("/smartewm/clients", d).then(r => r.data.client);
export const updateSmartewmClient = (id, d) => ax.put(`/smartewm/clients/${id}`, d).then(r => r.data.client);
export const deleteSmartewmClient = (id) => ax.delete(`/smartewm/clients/${id}`).then(r => r.data);
// SmartEWM SAP System Master CRUD.
export const createSmartewmSapSystem = (d) => ax.post("/smartewm/sap-systems", d).then(r => r.data.sapSystem);
export const updateSmartewmSapSystem = (id, d) => ax.put(`/smartewm/sap-systems/${id}`, d).then(r => r.data.sapSystem);
export const deleteSmartewmSapSystem = (id) => ax.delete(`/smartewm/sap-systems/${id}`).then(r => r.data);
export const setDefaultSmartewmSapSystem = (id) => ax.post(`/smartewm/sap-systems/${id}/default`).then(r => r.data.sapSystem);
// SmartEWM runtime context (current user's allowed Clients + SAP Systems).
export const getMySmartewmContext = () => axRoot.get("/me/smartewm-context").then(r => r.data);
// SmartEWM User Context (My Profile operational defaults).
export const getSmartewmUserContext = () => axRoot.get("/me/smartewm-user-context").then(r => r.data);
export const updateSmartewmUserContext = (payload) => axRoot.put("/me/smartewm-user-context", payload).then(r => r.data);
export const forgotPassword = (email) => ax.post("/auth/forgot-password", { email }).then(r => r.data);
export const validateResetToken = (token) => ax.get(`/auth/reset-token/${token}`).then(r => r.data);
export const resetPassword = (token, password) => ax.post("/auth/reset-password", { token, password }).then(r => r.data);

export const listQuestions = () => ax.get("/questions").then(r => r.data);
export const createQuestion = (d) => ax.post("/questions", d).then(r => r.data);
export const updateQuestion = (id, d) => ax.put(`/questions/${id}`, d).then(r => r.data);
export const deleteQuestion = (id) => ax.delete(`/questions/${id}`).then(r => r.data);
export const reorderQuestions = (orderedIds) => ax.post("/questions/reorder", { ordered_ids: orderedIds }).then(r => r.data);
export const getScoringAudit = () => ax.get("/scoring/audit").then(r => r.data);

export const listTriggers = () => ax.get("/triggers").then(r => r.data);
export const createTrigger = (d) => ax.post("/triggers", d).then(r => r.data);
export const updateTrigger = (id, d) => ax.put(`/triggers/${id}`, d).then(r => r.data);
export const deleteTrigger = (id) => ax.delete(`/triggers/${id}`).then(r => r.data);
export const reorderTriggers = (orderedIds) => ax.post("/triggers/reorder", { ordered_ids: orderedIds }).then(r => r.data);

// Help Knowledge Base (SAP Help Assistant)
export const listHelpTerms = () => ax.get("/help-knowledge").then(r => r.data);
export const createHelpTerm = (d) => ax.post("/help-knowledge", d).then(r => r.data);
export const updateHelpTerm = (id, d) => ax.put(`/help-knowledge/${id}`, d).then(r => r.data);
export const deleteHelpTerm = (id) => ax.delete(`/help-knowledge/${id}`).then(r => r.data);


// Consultant-mode assessment access
export const listAssessments = () => ax.get("/assessments").then(r => r.data);
export const getAssessmentDetail = (id) => ax.get(`/assessments/${id}`).then(r => r.data);
export const getAssessmentNarrative = (id) => ax.get(`/assessments/${id}/narrative`).then(r => r.data);
export const getRoiInputs = (id) => ax.get(`/assessments/${id}/roi-inputs`).then(r => r.data);
export const saveRoiInputs = (id, d) => ax.put(`/assessments/${id}/roi-inputs`, d).then(r => r.data);
export const processRoi = (id) => ax.post(`/assessments/${id}/roi-process`).then(r => r.data);
// Re-run the SmartEvaluate scoring engine on the latest saved answers
// (POST /api/assessments/{id}/process — not under /admin, so use axRoot).
export const reprocessAssessment = (id) => axRoot.post(`/assessments/${id}/process`).then(r => r.data);
export const getRoiOutput = (id) => ax.get(`/assessments/${id}/roi-output`).then(r => r.data);
// Admin-only: hard-delete an evaluation and its dependent records.
export const deleteAssessment = (id) => ax.delete(`/assessments/${id}`).then(r => r.data);
export const archiveAssessment = (id, payload) =>
  ax.post(`/assessments/${id}/archive`, payload).then(r => r.data);
export const restoreAssessment = (id) =>
  ax.post(`/assessments/${id}/restore`).then(r => r.data);

export const listCapabilities = () => ax.get("/capabilities").then(r => r.data);
export const createCapability = (d) => ax.post("/capabilities", d).then(r => r.data);
export const updateCapability = (id, d) => ax.put(`/capabilities/${id}`, d).then(r => r.data);
export const deleteCapability = (id) => ax.delete(`/capabilities/${id}`).then(r => r.data);

export const listRecommendations = () => ax.get("/recommendations").then(r => r.data);
export const createRecommendation = (d) => ax.post("/recommendations", d).then(r => r.data);
export const updateRecommendation = (id, d) => ax.put(`/recommendations/${id}`, d).then(r => r.data);

export const getRoi = () => ax.get("/roi-assumptions").then(r => r.data);
export const updateRoi = (d) => ax.put("/roi-assumptions", d).then(r => r.data);

export const listRoiModels = () => ax.get("/roi-models").then(r => r.data);
export const getRoiModel = (k) => ax.get(`/roi-models/${k}`).then(r => r.data);
export const createRoiModel = (d) => ax.post("/roi-models", d).then(r => r.data);
export const updateRoiModel = (k, d) => ax.put(`/roi-models/${k}`, d).then(r => r.data);
export const setRoiModelStatus = (k, s) => ax.patch(`/roi-models/${k}/status`, { status: s }).then(r => r.data);

export const getGroupRoi = (id) => ax.get(`/assessments/${id}/group-roi`).then(r => r.data);
export const saveGroupRoi = (id, groupId, d) => ax.put(`/assessments/${id}/group-roi/${groupId}`, d).then(r => r.data);
export const getCmRoi = (id) => ax.get(`/assessments/${id}/cm-roi`).then(r => r.data);
export const saveCmRoi = (id, d) => ax.put(`/assessments/${id}/cm-roi`, d).then(r => r.data);

export const listDemos = () => ax.get("/demo-profiles").then(r => r.data);
export const createDemo = (d) => ax.post("/demo-profiles", d).then(r => r.data);
export const updateDemo = (id, d) => ax.put(`/demo-profiles/${id}`, d).then(r => r.data);
export const deleteDemo = (id) => ax.delete(`/demo-profiles/${id}`).then(r => r.data);
export const duplicateDemo = (id) => ax.post(`/demo-profiles/${id}/duplicate`).then(r => r.data);
export const runDemoValidation = () => ax.post("/demo-profiles/validate").then(r => r.data);
export const getDemoValidation = () => ax.get("/demo-profiles/validation").then(r => r.data);

// --- SmartEvaluate Validation Profiles (Product QA regression framework) ---
// Completely separate from Demo Profiles. Admin-only.
export const listValidationProfiles = () => ax.get("/validation-profiles").then(r => r.data);
export const getValidationProfilesSummary = () => ax.get("/validation-profiles/summary").then(r => r.data);
export const getValidationProfile = (id) => ax.get(`/validation-profiles/${id}`).then(r => r.data);
export const createValidationProfile = (d) => ax.post("/validation-profiles", d).then(r => r.data);
export const updateValidationProfile = (id, d) => ax.put(`/validation-profiles/${id}`, d).then(r => r.data);
export const deleteValidationProfile = (id) => ax.delete(`/validation-profiles/${id}`).then(r => r.data);
export const duplicateValidationProfile = (id) => ax.post(`/validation-profiles/${id}/duplicate`).then(r => r.data);
export const activateValidationProfile = (id) => ax.post(`/validation-profiles/${id}/activate`).then(r => r.data);
export const deactivateValidationProfile = (id) => ax.post(`/validation-profiles/${id}/deactivate`).then(r => r.data);
export const runValidationProfile = (id) => ax.post(`/validation-profiles/${id}/run`).then(r => r.data);
export const runAllValidationProfiles = () => ax.post("/validation-profiles/run-all").then(r => r.data);

// --- SmartBid Validation Profiles (separate from SmartEvaluate) ---
export const listSmartBidValidationProfiles = () => ax.get("/smartbid-validation-profiles").then(r => r.data);
export const getSmartBidValidationSummary = () => ax.get("/smartbid-validation-profiles/summary").then(r => r.data);
export const getSmartBidValidationProfile = (id) => ax.get(`/smartbid-validation-profiles/${id}`).then(r => r.data);
export const runSmartBidValidationProfile = (id) => ax.post(`/smartbid-validation-profiles/${id}/run`).then(r => r.data);
export const runAllSmartBidValidationProfiles = () => ax.post("/smartbid-validation-profiles/run-all").then(r => r.data);
export const resetSmartBidValidationProfile = (id) => ax.post(`/smartbid-validation-profiles/${id}/reset`).then(r => r.data);
export const editSmartBidValidationExpected = (id, expected) => ax.put(`/smartbid-validation-profiles/${id}/expected`, { expected }).then(r => r.data);

// SmartImprove Demo Profiles — separate collection from SmartEvaluate.
export const listSiDemos = () => ax.get("/smartimprove/demo-profiles").then(r => r.data);
export const createSiDemo = (d) => ax.post("/smartimprove/demo-profiles", d).then(r => r.data);
export const updateSiDemo = (id, d) => ax.put(`/smartimprove/demo-profiles/${id}`, d).then(r => r.data);
export const deleteSiDemo = (id) => ax.delete(`/smartimprove/demo-profiles/${id}`).then(r => r.data);
export const duplicateSiDemo = (id) => ax.post(`/smartimprove/demo-profiles/${id}/duplicate`).then(r => r.data);
export const getAppSettings = () => ax.get("/app-settings").then(r => r.data);
export const updateAppSettings = (patch) => ax.put("/app-settings", patch).then(r => r.data);

export const getBranding = () => ax.get("/branding").then(r => r.data);
export const updateBranding = (d) => ax.put("/branding", d).then(r => r.data);
export const uploadBrandingLogo = (kind, file) => {
  const fd = new FormData();
  fd.append("logo", file);
  return ax.post(`/branding/logo/${kind}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);
};
export const removeBrandingLogo = (kind) => ax.delete(`/branding/logo/${kind}`).then(r => r.data);
export const getGuidelines = () => ax.get("/guidelines").then(r => r.data);
export const updateGuidelines = (content) => ax.put("/guidelines", { content }).then(r => r.data);


export const listPrompts = () => ax.get("/ai-prompts").then(r => r.data);
export const createPrompt = (d) => ax.post("/ai-prompts", d).then(r => r.data);
export const updatePrompt = (id, d) => ax.put(`/ai-prompts/${id}`, d).then(r => r.data);

export const listEmailTemplates = () => ax.get("/email-templates").then(r => r.data);
export const createEmailTemplate = (d) => ax.post("/email-templates", d).then(r => r.data);
export const updateEmailTemplate = (id, d) => ax.put(`/email-templates/${id}`, d).then(r => r.data);
export const testSendEmailTemplate = (id, payload) => ax.post(`/email-templates/${id}/test-send`, payload).then(r => r.data);

// Demo Requests — lightweight lead intake from the public Request Demo form.
// Surface lives in the Consultant Dashboard → Demo Requests module.
export const listDemoRequests = (status) =>
  ax.get("/demo-requests", { params: status ? { status } : undefined }).then(r => r.data);
export const getDemoRequest = (id) => ax.get(`/demo-requests/${id}`).then(r => r.data);
export const updateDemoRequestStatus = (id, status, note) =>
  ax.patch(`/demo-requests/${id}`, { status, note }).then(r => r.data);
export const deleteDemoRequest = (id) =>
  ax.delete(`/demo-requests/${id}`).then(r => r.data);

export const listImplementationTemplates = () => ax.get("/implementation-templates").then(r => r.data);
export const updateImplementationTemplate = (id, d) => ax.put(`/implementation-templates/${id}`, d).then(r => r.data);
export const cloneImplementationTemplate = (id) => ax.post(`/implementation-templates/${id}/clone`).then(r => r.data);

// Per-assessment consultant implementation inputs (working sheet)
export const getImplementationInputs = (assessmentId) =>
  ax.get(`/assessments/${assessmentId}/implementation-inputs`).then(r => r.data);
export const saveImplementationInputs = (assessmentId, payload) =>
  ax.put(`/assessments/${assessmentId}/implementation-inputs`, payload).then(r => r.data);

// Publish-gate readiness — returns {ready, blockers:[{section,field,message}], metrics}
export const getAssessmentReadiness = (assessmentId) =>
  ax.get(`/assessments/${assessmentId}/readiness`).then(r => r.data);

// URL of the formula-driven Excel export for the Implementation Plan.
// Rendered server-side by implementation_excel_service.py using openpyxl.
export const implementationPlanXlsxUrl = (assessmentId, versionId = null) => {
  const base = `${ax.defaults.baseURL}/assessments/${assessmentId}/implementation-plan.xlsx`;
  return versionId ? `${base}?version_id=${encodeURIComponent(versionId)}` : base;
};

// Word .docx proposal export — RFP submission_type + finalized only.
// Backend enforces both gates and returns 400 otherwise.
export const proposalDocxUrl = (assessmentId) =>
  `${ax.defaults.baseURL}/assessments/${assessmentId}/proposal.docx`;

// PowerPoint .pptx proposal presentation — same RFP + finalized gating.
// 13-slide executive deck, editable, 16:9, partner-logo branded.
export const proposalPptxUrl = (assessmentId) =>
  `${ax.defaults.baseURL}/assessments/${assessmentId}/proposal.pptx`;

// --- SmartEvaluate Consultant Recommendation Override ---------------------
// All three endpoints below are SmartEvaluate-only and reject overrides on
// assessments already released to the customer.
export const getEffectiveRecommendations = (assessmentId) =>
  ax.get(`/assessments/${assessmentId}/recommendations/effective`).then(r => r.data);

export const applyRecommendationOverride = (assessmentId, payload) =>
  ax.post(`/assessments/${assessmentId}/recommendations/override`, payload).then(r => r.data);

export const clearRecommendationOverride = (assessmentId, payload) =>
  ax.delete(`/assessments/${assessmentId}/recommendations/override`, { data: payload }).then(r => r.data);

// Customer-friendly Questionnaire export. One row per active question,
// expanded across representative warehouse types for module3 questions.
// Same .xlsx + StreamingResponse pattern as the implementation plan export.
export const questionnaireXlsxUrl = (assessmentId) =>
  `${ax.defaults.baseURL}/assessments/${assessmentId}/questionnaire.xlsx`;


// Assessment versioning — finalize, list, view, clone
export const finalizeAssessment = (assessmentId) =>
  ax.post(`/assessments/${assessmentId}/finalize`).then(r => r.data);
export const listAssessmentVersions = (assessmentId) =>
  ax.get(`/assessments/${assessmentId}/versions`).then(r => r.data);
export const getAssessmentVersion = (assessmentId, versionId) =>
  ax.get(`/assessments/${assessmentId}/versions/${versionId}`).then(r => r.data);
export const cloneAssessmentVersion = (assessmentId, versionId) =>
  ax.post(`/assessments/${assessmentId}/versions/${versionId}/clone`).then(r => r.data);

// Client logo (versioning extensions)
export const getClientLogo = (assessmentId) =>
  ax.get(`/assessments/${assessmentId}/logo`).then(r => r.data);
export const uploadClientLogo = (assessmentId, file) => {
  const fd = new FormData();
  fd.append("logo", file);
  return ax.post(`/assessments/${assessmentId}/logo`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);
};
export const deleteClientLogo = (assessmentId) =>
  ax.delete(`/assessments/${assessmentId}/logo`).then(r => r.data);

// --- Client Portal release (Send to Customer) ------------------------------
const CLIENT_API = `${process.env.REACT_APP_BACKEND_URL}/api/client`;
const axc = axios.create({ baseURL: CLIENT_API, withCredentials: true });

export const releaseToCustomer = (assessmentId, { emails, message } = {}) =>
  axc.post(`/assessments/${assessmentId}/release`, { emails, message }).then(r => r.data);
export const getReleaseStatus = (assessmentId) =>
  axc.get(`/assessments/${assessmentId}/release-status`).then(r => r.data);
export const getReleasedSnapshot = (assessmentId) =>
  axc.get(`/assessments/${assessmentId}/released`).then(r => r.data);

// Client-scoped: the dashboard itself asks "what have I been released?"
// Optional preview assessment_id is accepted for admin/consultant roles.
export const getMyRelease = (previewAssessmentId) =>
  axc.get(`/me/release`, {
    params: previewAssessmentId ? { assessment_id: previewAssessmentId } : undefined,
  }).then(r => r.data);

// Selections — live (not snapshotted) — drive the Selected → Review →
// Commercials → Approved decision pipeline.
export const listSelections = (assessmentId) =>
  axc.get(`/assessments/${assessmentId}/selections`).then(r => r.data);
export const createSelection = (assessmentId, body) =>
  axc.post(`/assessments/${assessmentId}/selections`, body).then(r => r.data);
export const updateSelection = (id, body) =>
  axc.put(`/selections/${id}`, body).then(r => r.data);
export const deleteSelection = (id) =>
  axc.delete(`/selections/${id}`).then(r => r.data);

